export class LoveMessageService {
    constructor() {
        this.apiUrl = '/api/chat';
        this.styles = {
            classic: {
                name: "经典文学",
                description: "融合中外经典名著中的情感表达",
                prompt: "以经典文学的优美语言描写"
            },
            poetry: {
                name: "诗歌风格",
                description: "包括中国古诗词和外国诗歌",
                prompt: "以诗人的浪漫笔触描写"
            },
            modern: {
                name: "现代都市",
                description: "简洁而富有感染力的现代表达",
                prompt: "以现代文学的简洁方式描写"
            },
            shakespeare: {
                name: "莎士比亚",
                description: "充满浪漫主义色彩的表达",
                prompt: "以莎士比亚的浪漫风格描写"
            },
            chinese: {
                name: "中国古典",
                description: "含蓄优雅的古典表达",
                prompt: "以中国古典文学的含蓄方式描写"
            }
        };
    }

    async generateLoveMessages(name, style) {
        try {
            const prompt = this._createPrompt(name, style);
            const response = await this._callGeminiAPI(prompt);
            return this._processResponse(response, name);
        } catch (error) {
            console.error('Generation error:', error);
            throw new Error(`情话生成服务暂时不可用: ${error.message}`);
        }
    }

    _createPrompt(name, style) {
        const selectedStyle = this.styles[style] || {
            name: style,
            description: "个性化风格",
            prompt: "以独特的方式"
        };

        return `作为一位专业的文学创作AI，请为${name}创作3条${selectedStyle.name}风格的情话。
${selectedStyle.description}，${selectedStyle.prompt}。

要求：
1. 每条情话不超过50字
2. 语言要优美动人
3. 符合${selectedStyle.name}的风格特点
4. 直接输出3行文本，每行一条情话
5. 不要添加任何额外的说明或标记
6. 不要使用序号或符号`;
    }

    async _callGeminiAPI(prompt) {
        try {
            console.log('Sending prompt:', prompt);
            
            const response = await fetch(this.apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ message: prompt })
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error('API Error:', errorData);
                throw new Error(errorData.error || '生成失败');
            }

            const data = await response.json();
            console.log('API Response:', data);

            return data.content;
        } catch (error) {
            console.error('API call error:', error);
            throw error;
        }
    }

    _processResponse(response, name) {
        try {
            // 如果响应是字符串，按行分割
            if (typeof response === 'string') {
                const lines = response
                    .split('\n')
                    .map(line => line.trim())
                    .filter(line => line.length > 0)
                    .slice(0, 3);  // 只取前3行

                return lines.map(line => ({
                    name: name,
                    content: this._sanitizeContent(line)
                }));
            }

            // 如果已经是数组格式
            if (Array.isArray(response)) {
                return response.map(item => ({
                    name: name,
                    content: this._sanitizeContent(
                        typeof item === 'string' ? item : item.content
                    )
                }));
            }

            throw new Error('无效的响应格式');
        } catch (error) {
            console.error('Response processing error:', error);
            return [{
                name: name,
                content: "抱歉，生成结果需要重试"
            }];
        }
    }

    _sanitizeContent(content) {
        if (!content) return "生成的内容无法解析";
        // 移除多余的空白字符和特殊标记
        return content
            .replace(/^[0-9.、\s]+/, '')  // 移除开头的序号
            .replace(/```/g, '')          // 移除代码块标记
            .replace(/\s+/g, ' ')         // 规范化空白
            .trim();
    }

    getAvailableStyles() {
        return Object.entries(this.styles).map(([key, style]) => ({
            id: key,
            name: style.name,
            description: style.description
        }));
    }
} 